import React from 'react'
import NotificationAutoInterUpdator from '../../../NotificationAutoInterUpdator'
import NotificationViewModel from '../../../NotificationViewModel'
import { NotificationBodyWithAccessCard } from '../../..'
import i18next from 'i18next'

const IdeaRemoveContributorNotif = (props) => {
  const { sender } = props
  NotificationAutoInterUpdator(props)
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        <NotificationBodyWithAccessCard
          {...props}
          notificationBodyContent={
            rtl
              ? `(ت)قام ${sender?.name} بحذفك من قائمة المشاركين و كذلك قناة المشاركة الخاصة بفكرته/فكرتها`
              : `${sender?.name} has removed you from his(her) idea contributors list and the associated channel`
          }
        />
      }
      buttonsArray={[]}
    />
  )
}

export default IdeaRemoveContributorNotif
